export interface IStarProps {
  gradientId: string;
  value: number;
}

const FILL_COLOR = '#ff7e00';
const BACKGROUND_COLOR = '#e8e9ec';

export function Star({ gradientId, value }: IStarProps) {
  const strokeFill = `url(#${gradientId})`;
  const offset = value * 100;
  const activeColor = offset === 0 ? BACKGROUND_COLOR : FILL_COLOR;
  const backColor = offset === 100 ? FILL_COLOR : BACKGROUND_COLOR;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 18">
      <defs>
        <linearGradient id={gradientId} y2="0%" x2="100%" y1="0%" x1="0%">
          <stop offset="0%" stopOpacity="1" stopColor={activeColor} />
          <stop offset={`${offset}%`} stopOpacity="1" stopColor={activeColor} />
          <stop offset={`${offset}%`} stopOpacity="0" stopColor={activeColor} />
          <stop offset={`${offset}%`} stopOpacity="1" stopColor={backColor} />
          <stop offset="100%" stopOpacity="1" stopColor={backColor} />
        </linearGradient>
      </defs>
      <path
        stroke={strokeFill}
        fill={`url(#${gradientId})`}
        d="M15.214 17.176l-.996-5.805 4.218-4.112-5.83-.847L10 1.13 7.393 6.412l-5.83.847 4.219 4.112-.996 5.805L10 14.436l5.214 2.74z"
      />
    </svg>
  );
}
